import "./App.css";
import { HelmetProvider } from "react-helmet-async";
import { Suspense } from "react";
import { useRoutes } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { routes } from "./route";

/**
 * RouteLayout Component
 * Renders the routes based on the provided path using `react-router-dom`.
 * @param {String} path - The path for rendering routes.
 * @returns {React.Element} - The rendered element based on the provided path.
 */
function RouteLayout({ path }) {
  const element = useRoutes(path);
  return element;
}

/**
 * App Component
 * The main application component that sets up the routing and suspense.
 * Uses `react-helmet-async` for managing document head elements.
 * Displays a loading spinner while routes are being loaded.
 * @returns {React.Element} - The main application component.
 */
function App() {
  return (
    <>
      <HelmetProvider>
        <Suspense
          fallback={
            <div className="d-flex align-items-center justify-content-center h-100 mainLoader">
              <Spinner variant="light" animation="border" role="status" />
            </div>
          }
        >
          {/* Render routes within Suspense */}
          <RouteLayout path={routes()} />
        </Suspense>
      </HelmetProvider>
    </>
  );
}

export default App;
